import React, { useEffect, useState } from 'react';
import LayoffModal from './LayoffModal';
import { refusalNoteError } from './FormControls';
import { useRecordRefusal } from './useLayoff';
import styles from './layoff.module.scss';

const RecordRefusalModal = ({ layoff, onClose }) => {
  const [note, setNote] = useState('');
  const [tried, setTried] = useState(false);
  const recordRefusal = useRecordRefusal({ onSuccess: onClose });

  useEffect(() => {
    setNote('');
    setTried(false);
  }, [layoff?.hash]);

  const noteError = refusalNoteError(note);
  const invalid = !!noteError;

  const submit = () => {
    setTried(true);
    if (!invalid) {
      recordRefusal.mutate({ hash: layoff.hash, note: note.trim() });
    }
  };

  return (
    <LayoffModal
      isOpen={!!layoff}
      title={`Record that ${layoff?.employee?.name ?? ''} refused to sign`}
      onClose={onClose}
    >
      <p>
        The notice is closed as &quot;Refused to sign&quot;. The lay-off still
        goes ahead on the effective date.
      </p>
      <label htmlFor='refusal-note' className={styles.field_label}>
        Note (required): describe in a sentence what happened and who was
        present
      </label>
      <textarea
        id='refusal-note'
        rows={3}
        className={`${styles.textarea} ${tried && invalid ? styles.invalid : ''}`}
        value={note}
        onChange={(event) => setNote(event.target.value)}
        placeholder='For example: notice explained in person on Oct 13; employee declined to sign'
      />
      {tried && invalid && (
        <span className={styles.error_text}>{noteError}</span>
      )}
      <div className={styles.modal_actions}>
        <button type='button' className='button grey' onClick={onClose}>
          Cancel
        </button>
        <button
          type='button'
          className='button'
          onClick={submit}
          disabled={recordRefusal.isLoading}
        >
          {recordRefusal.isLoading ? 'Recording...' : 'Record refusal'}
        </button>
      </div>
    </LayoffModal>
  );
};

export default RecordRefusalModal;
